import { render, staticRenderFns } from "./DividerWithText.vue?vue&type=template&id=bfb2b738&scoped=true&"
import script from "./DividerWithText.vue?vue&type=script&lang=js&"
export * from "./DividerWithText.vue?vue&type=script&lang=js&"
import style0 from "./DividerWithText.vue?vue&type=style&index=0&id=bfb2b738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2b738",
  null
  
)

export default component.exports